<template>
  <div class="scroll-container">
    <div class="content">
      <notifications></notifications>

      <div class="">

          <nuxt></nuxt>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    // document.addEventListener(
    //   'touchmove',
    //   event => {
    //     if (window.scrollY + window.innerHeight >= document.body.scrollHeight) {
    //       console.log('prevenir')
    //       event.preventDefault()
    //     }
    //   },
    //   { passive: false }
    // )
  },
  beforeDestroy() {
    // document.removeEventListener('touchmove', this.preventDefault, { passive: false })
  }
}
</script>
<style scoped lang="scss">
// html,
// body {
//   overscroll-behavior: none;
//   overflow: hidden;
// }

// .scroll-container {
//   height: 100vh;
//   overflow-y: auto;
//   -webkit-overflow-scrolling: touch;
// }
</style>
